module.exports = __webpack_public_path__ + "static/media/exploreIcon.4dfb0801.svg";